import { render, staticRenderFns } from "./ChangeAddress.vue?vue&type=template&id=0511ba3a&"
import script from "./ChangeAddress.vue?vue&type=script&lang=js&"
export * from "./ChangeAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports